import {
  buttonDangerClasses,
  buttonLinkClasses,
  buttonSecondaryClasses,
  labelDangerClasses,
  labelLinkClasses,
  labelPrimaryClasses,
  labelSecondaryClasses,
  primaryButtonClasses,
  primaryButtonDisabledClasses,
} from "~/assets/styles/classes/ButtonClasses";

interface Prop {
  label?: string;
  disabled?: boolean;
  firstIcon?: React.ReactNode;
  secondIcon?: React.ReactNode;
  primary?: boolean;
  secondary?: boolean;
  link?: boolean;
  danger?: boolean;
  buttonHandlerAction?: () => void;
}

export const SIMPLButtonCustomized = (props: Prop) => {
  const {
    disabled,
    label,
    firstIcon,
    secondIcon,
    primary,
    secondary,
    link,
    danger,
    buttonHandlerAction,
  } = props;

  const primaryButtonDisabled = primaryButtonDisabledClasses(disabled!);

  const renderContent = (labelClass: string) => (
    <div className="relative inline-flex items-center justify-center w-full h-full gap-1">
      {firstIcon && <span className={labelClass}>{firstIcon}</span>}
      {label && <span className={`${labelClass} mx-auto`}>{label}</span>}
      {secondIcon && <span className={labelClass}>{secondIcon}</span>}
    </div>
  );

  if (disabled) {
    return (
      <button className={primaryButtonDisabled} disabled>
        {renderContent(labelPrimaryClasses)}
      </button>
    );
  }

  if (primary) {
    return (
      <button
        className={primaryButtonClasses(disabled!)}
        disabled={disabled}
        onClick={buttonHandlerAction}
      >
        {renderContent(labelPrimaryClasses)}
      </button>
    );
  }

  if (secondary) {
    return (
      <button
        className={buttonSecondaryClasses(disabled!)}
        disabled={disabled}
        onClick={buttonHandlerAction}
      >
        {renderContent(labelSecondaryClasses)}
      </button>
    );
  }

  if (link) {
    return (
      <button
        className={buttonLinkClasses(disabled!)}
        disabled={disabled}
        onClick={buttonHandlerAction}
      >
        {renderContent(labelLinkClasses)}
      </button>
    );
  }

  if (danger) {
    return (
      <button
        className={buttonDangerClasses(disabled!)}
        disabled={disabled}
        onClick={buttonHandlerAction}
      >
        {renderContent(labelDangerClasses)}
      </button>
    );
  }

  return null;
};
